<template>
  <div class="product">
    <div class="product-box">
      <div class="bigtitle">
        {{ resDatatiter.title }}
      </div>
      <div class="game-box">
        <div class="gameul">
          <div class="title-div">
            <div class="title" v-if="resDatas" v-html="resDatas.title">
            </div>
            <div class="title" v-if="resDatas">
              {{ resDatas.mintitle }}
            </div>
            <p class="time" v-if="resDatas">{{ resDatas.time }}</p>
          </div>
          <div class="content">
            <div
              class="content-html"
              v-html="resDatas.content"
              v-if="resDatas"
            ></div>

            <p>
              {{ resDatas.tttext
              }}<a class="urltext" v-if="resDatas" :href="resDatas.tturl">{{
                resDatas.tturl
              }}</a>
            </p>
            <img
              v-if="resDatas"
              class="gameIcon"
              :src="require('@/assets/images/news/' + resDatas.contentImg + '.jpg')"
            />
          </div>
        </div>
        <a class="back-btu" href="javascript:history.back(-1)">BACK</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      resDatas: {
        id: 0,
        contentImg: '1-1'
      },
      resDatatiter: "",
    };
  },
  props: {
    resData: {},
  },
  watch: {
    resData(newData) {
      console.log(newData);
      this.resDatatiter = newData;
      this.resDatas = newData.newsList[this.$route.query.id];
    },
  },
  methods: {},
  mounted() {
    this.$parent.getlan();
  },
};
</script>

<style scoped>
.product {
  background: url("~@/assets/images/news/bg3.jpg") top center no-repeat, white;
  background-size: cover;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
  padding-top: 5%;
  padding-bottom: 5%;
}

.product-box {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.game-box {
  max-width: 80%;
  box-sizing: border-box;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  -webkit-box-shadow: 3px 0px 24px 8px rgba(39, 27, 8, 0.1);
  box-shadow: 3px 0px 24px 8px rgba(39, 27, 8, 0.1);
  border-radius: 10px;
  margin-top: 4%;
  position: relative;
}

.gameul {
  padding: 2%;
  box-sizing: border-box;
  min-height: 600px;
  height: 100%;
}

.product-list {
  padding: 2% 14%;
  border-bottom: 1px solid #9f9f9f;
  font-size: 0;
  position: relative;
}

/* .gameul li:nth-last-child(1){
    border-bottom: none;
    margin-bottom: 0;
  }
   */
.gameul li:nth-of-type(1) {
  border-bottom: none;
}

.product-list::after {
  content: "";
  display: block;
  clear: both;
}

.bigtitle {
  font-size: 70px;
  text-align: center;
  background: url("~@/assets/images/title-bottom.png") center bottom no-repeat;
  background-size: auto;
  font-family: "dbtfont";
}

.title-div {
  background: url("~@/assets/images/fgicon.png") bottom center no-repeat;
  background-size: 100% auto;
  padding-bottom: 30px;
  width: 94%;
  margin: auto;
}

.title {
  font-size: 42px;
  font-weight: 600;
  text-align: center;
  margin: auto;
  text-shadow: 3px 3px 3px white;
  color: rgb(56, 83, 101);
  font-family: "btfont";
}

.time {
  font-size: 18px;
  text-align: center;
  margin-top: 1%;
  color: rgb(162, 166, 169);
  font-family: "dbtfont";
}

.content {
  width: 88%;
  margin: 3% auto 0;
  font-size: 18px;
  padding-bottom: 3%;
}

.gameIcon {
  max-width: 100%;
}

.content-html {
  margin-bottom: 2%;
  font-size: 28px;
  letter-spacing: 3px;
}

.urltext {
  font-size: 28px;
  line-height: 50px;
  text-decoration: underline;
  color: blue;
}

.back-btu {
  font-size: 24px;
  position: absolute;
  padding: 5px 50px;
  background-color: rgb(247, 78, 78);
  color: white;
  border-radius: 5px;
  cursor: pointer;
  height: 60px;
  padding: 0 5%;
  line-height: 60px;
  right: 0;
  bottom: -70px;
}

.content {
  font-size: 28px;
}

@media screen and (max-width: 1000px) {
  .product {
    background: url('~@/assets/images/news/h5-bg3.jpg') top center no-repeat;
    background-size: cover;
    padding: 0 5% 5%;
    padding-top: 10%;
    padding-bottom: 20%;
  }

  .product-list {
    padding: 5% 3%;
    background-color: white;
  }

  .product-download {
    width: 100%;
    margin-left: 0;
    margin-top: 5%;
  }

  .download-box a:nth-of-type(2) {
    margin: 0 3%;
  }

  .gameIcon {
    width: 100%;
    display: block;
  }

  .download-box span {
    font-size: 14px;
  }

  .game-box {
    max-width: 100%;
  }

  .gameul {
    min-height: 400px;
  }

  .title {
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    padding: 5% 0 0;
    width: 100%;
    margin: auto;
  }

  .bigtitle {
    font-size: 30px;
    background: url("~@/assets/images/yd-title-bottom.png") center bottom
      no-repeat;
    background-size: 30%;
  }

  .content {
    width: 90%;
    margin: 5% auto;
    font-size: 16px;
    padding-bottom: 5%;
  }

  .content-html {
    margin-bottom: 2%;
    font-size: 16px;
    letter-spacing: 2px;
  }

  .title-div {
    width: 94%;
    padding-bottom: 5%;
  }

  .urltext {
    font-size: 16px;
    line-height: 30px;
  }

  .back-btu {
    font-size: 16px;
    height: 50px;
    padding: 0 6%;
    line-height: 50px;
    right: 0;
    bottom: -60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/new-details.vue